import { CSSObject } from '@emotion/react';
import { theme } from 'styles';
import { mobile } from 'styles/media';

const { color } = theme;

const section: CSSObject = {
  display: 'flex',
  flexDirection: 'column',
  gap: 16,
};

const nameRow: CSSObject = {
  display: 'flex',
  alignItems: 'center',
  gap: 8,
  label: { fontSize: 14, fontWeight: 700, color: color.text, flexShrink: 0 },
  input: { maxWidth: 400 },
  [mobile]: { flexWrap: 'wrap' },
};

const meta: CSSObject = {
  fontSize: 13,
  color: color.textMuted,
};

const footer: CSSObject = {
  display: 'flex',
  justifyContent: 'flex-end',
  alignItems: 'center',
  gap: 8,
  [mobile]: {
    '> button': { flex: 1, height: 48 },
  },
};

const link: CSSObject = {
  textDecoration: 'underline',
  cursor: 'pointer',
};

const modalBody: CSSObject = {
  width: 1000,
  maxWidth: '80vw',
  display: 'flex',
  flexDirection: 'column',
  gap: 16,
  [mobile]: { width: '100%', maxWidth: 'none' },
};

const deleteWarning: CSSObject = {
  marginTop: 12,
  fontSize: 13,
  color: color.error,
};

export { section, nameRow, meta, footer, link, modalBody, deleteWarning };
